module.exports = __webpack_public_path__ + "img/ios_btn.6c6aa931.png";